import React, {
  createContext,
  Dispatch,
  FC,
  PropsWithChildren,
  useContext,
  useReducer,
} from 'react';
import {
  CheckoutReducer,
  checkoutReducerInitialState,
  CheckoutState,
} from './Checkout.reducer';

const CheckoutContext = createContext<{
  state: CheckoutState;
  dispatch: Dispatch<any>;
}>({ state: checkoutReducerInitialState, dispatch: () => null });

interface CheckoutProviderProps {
  initialState?: CheckoutState;
}

export const CheckoutProvider: FC<PropsWithChildren<CheckoutProviderProps>> = ({
  children,
  initialState,
}) => {
  const [state, dispatch] = useReducer(
    CheckoutReducer,
    initialState ?? checkoutReducerInitialState,
  );
  return (
    <CheckoutContext.Provider value={{ state, dispatch }}>
      {children}
    </CheckoutContext.Provider>
  );
};

export function useCheckoutStore() {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error('useCheckoutStore must be used within CheckoutProvider');
  }
  return context;
}
